import { Box, Title, Text, Accent } from '@nerdwallet/currency';
import classNames from 'classnames';
import getTextColor from '../../../lib/text-color-config';
import styles from '../universal-text.module.scss';

const getTextColorStyle = (textColorOptions, propertyName = 'color') => {
  const { textColor: color } = getTextColor(textColorOptions);
  return { [propertyName]: color };
};

const htmlOutputParser = (content, enableHtml) => {
  if (enableHtml) {
    // eslint-disable-next-line react/no-danger
    return <span dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return content;
};

export const getTextComponent = (
  text,
  textTypeValue,
  textDecoration,
  fontWeight,
  alignment,
  colorOptions,
  textSize,
  customTextSize,
  enableHtmlOutput
) => {
  const type = {
    text: (
      <Box
        className={classNames(styles.text, [textDecoration])}
        style={{
          ...getTextColorStyle(colorOptions),
          fontWeight,
          textAlign: alignment,
        }}
      >
        <Text component="p" size={textSize}>
          {htmlOutputParser(text, enableHtmlOutput)}
        </Text>
      </Box>
    ),
    title: (
      <Title
        className={classNames(styles.text, [textDecoration])}
        style={{
          ...getTextColorStyle(colorOptions),
          textAlign: alignment,
        }}
        size={textSize}
      >
        {htmlOutputParser(text, enableHtmlOutput)}
      </Title>
    ),
    accent: (
      <Box
        className={classNames(styles.accent, [textDecoration])}
        style={{
          ...getTextColorStyle(colorOptions),
          fontWeight,
          textAlign: alignment,
        }}
      >
        <Accent size={textSize}>
          {htmlOutputParser(text, enableHtmlOutput)}
        </Accent>
      </Box>
    ),
    custom: (
      <span
        className={classNames(styles.text, [textDecoration])}
        style={{
          ...getTextColorStyle(colorOptions),
          fontSize: customTextSize,
          textAlign: alignment,
          display: 'inherit',
        }}
      >
        {htmlOutputParser(text, enableHtmlOutput)}
      </span>
    ),
  };
  return type[textTypeValue];
};
